import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SistemaQuejas from './components/SistemaQuejas';
import ListaQuejas from './components/ListaQuejas';
import Login from './auth/login/Login';
import CompletarTarea from './components/CompletarTarea'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'; 

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/administrador/login" />;
};

function App() {
  return (
    <Router basename="/">
      <div className="App">
        <Routes>
          <Route path="/tareas/completar/:id" element={<CompletarTarea />} />
          
          <Route path="/sistemaSugerencias" element={<SistemaQuejas />} />
          
          <Route path="/administrador/login" element={<Login />} />
          
          <Route
            path="/administrador/sugerencias"
            element={
              <ProtectedRoute>
                <ListaQuejas />
              </ProtectedRoute>
            }
          />

          <Route path="/administrador" element={<Navigate to="/administrador/sugerencias" replace />} />
          
          <Route path="/sugerencias" element={<Navigate to="/administrador/sugerencias" replace />} />

          <Route path="/" element={<Navigate to="/sistemaSugerencias" replace />} />
          
          <Route path="*" element={<Navigate to="/sistemaSugerencias" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;